var PCSPHP_TRANSLATIONS_PT = {
	lang: {
		'es': 'Espanhol',
		'en': 'Inglês',
		'fr': 'Francês',
		'de': 'Alemão',
		'it': 'Italiano',
		'pt': 'Português',
	},
	langShort: {
		'es': 'ES',
		'en': 'EN',
		'fr': 'FR',
		'de': 'DE',
		'it': 'IT',
		'pt': 'PT',
	},
	titles: {
		error: 'Erro',
		success: 'Sucesso',
		created: 'Criado',
		edited: 'Editado',
	},
	errors: {
		pass_not_match: 'Erro: as senhas devem coincidir.',
		unexpected_error: 'Ocorreu um erro inesperado.',
		unexpected_error_try_later: 'Ocorreu um erro inesperado. Tente novamente mais tarde.',
		name_is_required: 'O nome é obrigatório.',
		name_should_be_string: 'O nome deve ser uma string.',
		lastname_is_required: 'O sobrenome é obrigatório.',
		lastname_should_be_string: 'O sobrenome deve ser uma string.',
		email_is_required: 'O email é obrigatório.',
		email_should_be_string: 'O email deve ser uma string.',
		user_is_required: 'O nome de usuário é obrigatório.',
		user_should_be_string: 'O nome de usuário deve ser uma string.',
		password_is_required: 'A senha é obrigatória.',
		password_should_be_string: 'A senha deve ser uma string.',
	},
	semantic_calendar: {
		days: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
		months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
		monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
		today: 'Hoje',
		now: 'Agora',
		am: 'AM',
		pm: 'PM',
	},
	semantic_form: {
		text: {
			unspecifiedRule: 'Por favor, insira um valor válido',
			unspecifiedField: 'Este campo'
		},
		prompt: {
			empty: '{name} deve ter um valor',
			checked: '{name} deve estar marcado',
			email: '{name} deve ser um email válido',
			url: '{name} deve ser uma URL válida',
			regExp: '{name} não tem o formato correto',
			integer: '{name} deve ser um número inteiro',
			decimal: '{name} deve ser um número decimal',
			number: '{name} deve ser um número',
			is: '{name} deve ser \'{ruleValue}\'',
			isExactly: '{name} deve ser exatamente \'{ruleValue}\'',
			not: '{name} não pode ser \'{ruleValue}\'',
			notExactly: '{name} não pode ser exatamente \'{ruleValue}\'',
			contain: '{name} não pode conter \'{ruleValue}\'',
			containExactly: '{name} não pode conter exatamente \'{ruleValue}\'',
			doesntContain: '{name} deve conter \'{ruleValue}\'',
			doesntContainExactly: '{name} deve conter exatamente \'{ruleValue}\'',
			minLength: '{name} deve conter pelo menos {ruleValue} caracteres',
			length: '{name} deve conter pelo menos {ruleValue} caracteres',
			exactLength: '{name} deve conter exatamente {ruleValue} caracteres',
			maxLength: '{name} não pode conter mais de {ruleValue} caracteres',
			match: '{name} deve coincidir com o campo {ruleValue}',
			different: '{name} deve ser diferente do campo {ruleValue}',
			creditCard: '{name} deve ser um número de cartão de crédito válido',
			minCount: '{name} deve ter pelo menos {ruleValue} opções',
			exactCount: '{name} deve ter exatamente {ruleValue} opções',
			maxCount: '{name} deve ter {ruleValue} ou menos opções'
		}
	},
	semantic_search: {
		error: {
			logging: "Erro no log de depuração, encerrando.",
			maxResults: "Os resultados devem ser uma matriz para usar a configuração maxResults",
			method: "O método chamado não está definido.",
			noEndpoint: "Nenhum endpoint de busca foi especificado",
			noNormalize: "A configuração \"ignoreDiacritics\" será ignorada. O navegador não suporta String().normalize(). Considere incluir <https://cdn.jsdelivr.net/npm/unorm@1.4.1/lib/unorm.min.js> como polyfill.",
			noResults: "Sua busca não retornou resultados",
			noResultsHeader: "Sem resultados",
			noTemplate: "Nenhum nome de template válido foi especificado.",
			oldSearchSyntax: "A configuração searchFullText foi renomeada para fullTextSearch. Atualize sua configuração.",
			serverError: "Ocorreu um problema ao consultar o servidor.",
			source: "Busca não disponível. Nenhuma fonte especificada e o módulo API semantic não foi incluído.",
		},
	},
	datatables: {
		lang: {
			"decimal": ",",
			"emptyTable": "Nenhuma informação disponível",
			"info": "Mostrando de _START_ até _END_ de _TOTAL_ registros",
			"infoEmpty": "Mostrando 0 até 0 de 0 registros",
			"infoFiltered": "(filtrado de _MAX_ registros)",
			"infoPostFix": "",
			"thousands": ".",
			"lengthMenu": "Mostrar _MENU_ registros",
			"loadingRecords": "Carregando...",
			"processing": "Processando...",
			"search": "",
			"searchPlaceholder": "Buscar...",
			"zeroRecords": "Nenhum resultado encontrado",
			"paginate": {
				"first": "Primeiro",
				"last": "Último",
				"next": "Próximo",
				"previous": "Anterior"
			},
			"aria": {
				"sortAscending": ": ativar para ordenar a coluna em ordem crescente",
				"sortDescending": ": ativar para ordenar a coluna em ordem decrescente"
			}
		}
	},
	date: {
		days: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'],
		daysLetter: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
		months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
		monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
		today: 'Hoje',
		now: 'Agora',
		am: 'AM',
		pm: 'PM',
	},
	messenger: {
		'Error': 'Erro',
		'Ha ocurrido un error desconocido.': 'Ocorreu um erro desconhecido.',
		'¡Listo!': 'Pronto!',
	},
	loginForm: {
		'Error': 'Erro',
		'Ha ocurrido un error inesperado, intente más tarde.': 'Ocorreu um erro inesperado, tente novamente mais tarde.',
		'Si continua con problemas para ingresar, por favor utilice la ayuda.': 'Se você continuar tendo problemas para entrar, por favor, use a ajuda.',
		'Por favor, verifique los datos de ingreso y vuelva a intentar.': 'Por favor, verifique os dados de login e tente novamente.',
		'Por favor, ingrese al siguiente enlace para desbloquear su usuario.': 'Por favor, acesse o seguinte link para desbloquear seu usuário.',
		'Se ha presentado un error al momento de ingresar, por favor intente nuevamente.': 'Ocorreu um erro ao tentar entrar, por favor, tente novamente.',
		'CONTRASEÑA_INVÁLIDA': '<span class="mark">Inválido</span> <span class="text">senha</span>',
		'USUARIO_BLOQUEADO': '<span class="text">Usuário</span> <span class="mark">bloqueado</span>',
		'USUARIO_INEXISTENTE': '<span class="text">O usuário</span> <span class="mark">%r</span> <span class="text">não existe</span>',
		'ERROR_AL_INGRESAR': 'Falha no login',
	},
	userProblems: {
		'Será solucionada muy pronto, por favor verifique su correo en las próximas horas. <br> El correo puede estar en "No deseado", por favor revise la carpeta de Spam. El remitente del correo es <strong>%r</strong>.': 'Será resolvido muito em breve, por favor, verifique seu e-mail nas próximas horas. <br> O e-mail pode estar na pasta "Spam", por favor, verifique a pasta de spam. O remetente do e-mail é <strong>%r</strong>.',
		'Ingrese el código enviado a su correo, el correo puede estar en "No deseado", por favor revise la carpeta de Spam. El remitente del correo es <strong>%r</strong>.': 'Insira o código enviado para seu e-mail, o e-mail pode estar na pasta "Spam", por favor, verifique a pasta de spam. O remetente do e-mail é <strong>%r</strong>.',
		'El correo ingresado no está asociado a ningún usuario, por favor ingrese otra cuenta de correo o puede crear una solicitud de soporte para asociar ese correo a su cuenta.': 'O e-mail inserido não está associado a nenhum usuário, por favor insira outra conta de e-mail ou você pode criar um pedido de suporte para associar esse e-mail à sua conta.',
		'El código ingresado está errado, por favor vuelva a ingresar el código, solicite uno nuevo o cree una solicitud de soporte para informar del error.': 'O código inserido está errado, por favor, insira o código novamente, solicite um novo ou crie um pedido de suporte para relatar o erro.',
		'Ingrese con su usuario y la nueva contraseña': 'Faça login com seu nome de usuário e a nova senha',
		'Las contraseñas no coinciden': 'As senhas não coincidem',
	},
	avatar: {
		'Confirmación': 'Confirmação',
		'¿Seguro de guardar el avatar?': 'Tem certeza de que deseja salvar o avatar?',
		'Cargando...': 'Carregando...',
		'¿Seguro de guardar la foto de perfil?': 'Tem certeza de que deseja salvar a foto do perfil?',
		'Sí': 'Sim',
		'No': 'Não',
	},
	public: {
		'Ver más': 'Leia mais',
	},
}
